import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer id="footer">
        Copyright &#169; 2023 Khushi Pandey. All right received.
    </footer>
  )
}

export default Footer
